import { put, select, takeLatest } from 'redux-saga/effects'
import { randomNumber } from '../../../utilities'
import { getRelationshipsAndGuarantors } from '../selectors/getRelationshipsAndGuarantors.selector'
import {
  clearRelationshipsAndGuarantorsData,
  setRelationshipsAndGuarantorsList,
} from '../store/relationshipsAndGuarantors.action'
import { RelationshipsAndGuarantorsConstants } from '../store/relationshipsAndGuarantors.constants'
import { IRelationshipsAndGuarantorsState } from '../store/relationshipsAndGuarantors.types'

export function* addRelationshipsAndGuarantors() {
  const relationshipsAndGuarantors: IRelationshipsAndGuarantorsState = yield select(getRelationshipsAndGuarantors)
  const { relationshipsAndGuarantorsData, relationshipsAndGuarantorsList } = relationshipsAndGuarantors
  const { key } = relationshipsAndGuarantorsData
  const selectedRGIndex = relationshipsAndGuarantorsList.findIndex((rgInfo) => rgInfo.key === key)
  const updatedRelationshipsAndGuarantorsList = [...relationshipsAndGuarantorsList]
  if (selectedRGIndex >= 0) {
    updatedRelationshipsAndGuarantorsList[selectedRGIndex] = relationshipsAndGuarantorsData
  } else {
    updatedRelationshipsAndGuarantorsList.push({ ...relationshipsAndGuarantorsData, key: randomNumber().toString() })
  }
  yield put(setRelationshipsAndGuarantorsList(updatedRelationshipsAndGuarantorsList))
  yield put(clearRelationshipsAndGuarantorsData())
}

export function* addRelationshipsAndGuarantorsSaga() {
  yield takeLatest(
    [RelationshipsAndGuarantorsConstants.ADD_RELATIONSHIPS_AND_GUARANTORS],
    addRelationshipsAndGuarantors
  )
}
